// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__38Abn","row":"ProcedureTreatmentSummary_row__bmHZW"};